import { cva, VariantProps } from "class-variance-authority"
import { Component, type HTMLAttributes } from "vue"
import { RouteLocationNamedRaw, RouteLocationRaw } from "vue-router"

export const NAV_DEBOUNCE_MS = 100

export { default as NavBottombar } from "./NavBottombar.vue"
export { default as NavDropdown } from "./NavDropdown.vue"
export { default as NavLink } from "./NavLink.vue"
export { default as NavLogo } from "./NavLogo.vue"
export { default as NavMenu } from "./NavMenu.vue"
export { default as NavSidebar } from "./NavSidebar.vue"
export { default as NavTopbar } from "./NavTopbar.vue"

export type NavItem = {
    name: string
    to?: RouteLocationRaw | RouteLocationNamedRaw
    modal?: {
        component: Component
        props?: Record<string, any>
    }
    items?: Omit<NavItem, "items">[]
    button?: boolean
    emphasize?: boolean
    class?: HTMLAttributes["class"]
}

export const navMenuVariants = cva(
    "flex",
    {
        variants: {
            variant: {
                default: "gap-2",
                vertical: "flex-col items-start gap-4"
            }
        },
        defaultVariants: {
            variant: "default"
        }
    }
)

export type NavMenuVariants = VariantProps<typeof navMenuVariants>